import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function Privatlivspolitik() {
  return (
    <div>
      <SEO
        title="Privatlivspolitik | Caspers Træservice"
        description="Læs om, hvordan Caspers Træservice passer på dine personoplysninger."
      />

      {/* Header banner */}
      <section className="bg-[#152E22] text-[#FBF9F5] pt-32 pb-14 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-3">
            Privatlivspolitik
          </h1>
          <p className="text-sm sm:text-base text-[#BAC7BF]">
            Kort og overskueligt om, hvordan vi behandler dine oplysninger.
          </p>
        </div>
      </section>

      {/* Enkelt indhold */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-[#FBF9F5]">
        <div className="max-w-2xl mx-auto bg-white p-6 sm:p-10 rounded-2xl border border-[#E5DDCF] shadow-sm space-y-8 text-[#1E3E2E]">

          {/* 1. Dataansvarlig */}
          <div>
            <h2 className="text-lg sm:text-xl font-bold text-[#152E22] mb-2">
              1. Dataansvarlig
            </h2>
            <p className="text-sm sm:text-base text-[#3C5345] leading-relaxed mb-3">
              Caspers Træservice er ansvarlig for de oplysninger, vi modtager fra dig:
            </p>
            <div className="bg-[#F8F5EE] p-4 rounded-xl text-sm space-y-1 text-[#1E3E2E]">
              <p className="font-semibold text-[#152E22]">Caspers Træservice</p>
              <p>CVR: 37232521</p>
              <p>Folevej 23, 6510 Gram</p>
              <p>Telefon: <a href="tel:42169230" className="text-[#D9691E] font-medium hover:underline">42 16 92 30</a></p>
              <p>E-mail: <a href="mailto:info@casperstraeservice.dk" className="text-[#D9691E] font-medium hover:underline">info@casperstraeservice.dk</a></p>
            </div>
          </div>

          {/* 2. Hvad vi indsamler og hvorfor */}
          <div>
            <h2 className="text-lg sm:text-xl font-bold text-[#152E22] mb-2">
              2. Hvad vi indsamler og hvorfor
            </h2>
            <p className="text-sm sm:text-base text-[#3C5345] leading-relaxed mb-2">
              Når du kontakter os for et tilbud eller får udført en opgave, indsamler vi kun de oplysninger, du selv giver os:
            </p>
            <ul className="list-disc list-inside text-sm sm:text-base text-[#3C5345] space-y-1">
              <li>Navn, telefonnummer og e-mailadresse</li>
              <li>Adresse/arbejdssted og opgavebeskrivelse (samt evt. fotos af træer/have)</li>
            </ul>
            <p className="text-sm text-[#3C5345] mt-2">
              <strong>Formål:</strong> Oplysningerne bruges udelukkende til at besvare din henvendelse, give et tilbud, udføre det aftalte arbejde samt fakturere.
            </p>
          </div>

          {/* 3. Opbevaring og sletning */}
          <div>
            <h2 className="text-lg sm:text-xl font-bold text-[#152E22] mb-2">
              3. Opbevaring og sletning
            </h2>
            <ul className="list-disc list-inside text-sm sm:text-base text-[#3C5345] space-y-1.5">
              <li>
                <strong>Forespørgsler:</strong> Henvendelser og tilbud, der ikke bliver til en aftale, slettes senest efter 6 måneder.
              </li>
              <li>
                <strong>Kunder og fakturaer:</strong> Oplysninger vedrørende udført arbejde og fakturaer gemmes i 5 år jf. bogføringslovens krav.
              </li>
            </ul>
          </div>

          {/* 4. Videregivelse */}
          <div>
            <h2 className="text-lg sm:text-xl font-bold text-[#152E22] mb-2">
              4. Videregivelse af oplysninger
            </h2>
            <p className="text-sm sm:text-base text-[#3C5345] leading-relaxed">
              Vi sælger eller videregiver aldrig dine oplysninger til tredjepart. Vi benytter udelukkende nødvendige IT- og administrationssystemer (webhosting, e-mail og regnskab), der behandler data sikkert inden for EU.
            </p>
          </div>

          {/* 5. Cookies */}
          <div>
            <h2 className="text-lg sm:text-xl font-bold text-[#152E22] mb-2">
              5. Cookies og sporing
            </h2>
            <p className="text-sm sm:text-base text-[#3C5345] leading-relaxed">
              Hjemmesiden bruger <strong>ikke</strong> marketing-cookies, sporingspixels eller analyseværktøjer fra tredjeparter. Vi anvender kun teknisk nødvendige funktioner for, at hjemmesiden fungerer.
            </p>
          </div>

          {/* 6. Dine rettigheder */}
          <div>
            <h2 className="text-lg sm:text-xl font-bold text-[#152E22] mb-2">
              6. Dine rettigheder
            </h2>
            <p className="text-sm sm:text-base text-[#3C5345] leading-relaxed mb-3">
              Du har ret til at få indsigt i, hvilke oplysninger vi har om dig, og du kan til enhver tid bede om at få rettet eller slettet dine oplysninger (medmindre lovgivning kræver, at vi gemmer dem).
            </p>
            <p className="text-sm sm:text-base text-[#3C5345] leading-relaxed">
              Kontakt os på <a href="mailto:info@casperstraeservice.dk" className="text-[#D9691E] font-medium hover:underline">info@casperstraeservice.dk</a>, hvis du ønsker at gøre brug af dine rettigheder. Du har også mulighed for at klage til <a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer" className="text-[#D9691E] font-medium hover:underline">Datatilsynet</a>.
            </p>
          </div>

          {/* Tilbage link */}
          <div className="pt-4 border-t border-[#E5DDCF] flex justify-between items-center text-sm">
            <span className="text-xs text-[#8BA194]">Opdateret: 2026</span>
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 font-semibold text-[#152E22] hover:text-[#D9691E] transition-colors"
            >
              <i className="fa-solid fa-arrow-left text-xs" aria-hidden="true" />
              Tilbage til forsiden
            </Link>
          </div>

        </div>
      </section>
    </div>
  );
}
